import { createAction } from "@reduxjs/toolkit";
import { clientUrlPath } from "common/utilities/browser/url/url";
import { deepClone } from "common/utilities/core/object";
import type * as I from "core/api/coreApiClient";
import type { AppThunk } from "core/redux/store/configureStore.types";
import isUrl from "is-url";

import { urls } from "../../../../api/urls.ts";

export const loadingConfiguration = createAction("configuration/loadingConfiguration");

export const configurationLoaded = createAction(
  "configuration/configurationLoaded",
  (
    source: "static" | "session" | "login",
    configuration: I.AppConfiguration,
    timeZone: string,
    imgRootUrl: string,
  ) => ({
    payload: {
      source,
      configuration,
      timeZone,
      imgRootUrl,
    },
  }),
);

export const loadingConfigurationFailed = createAction("configuration/loadingConfigurationFailed");

/**
 * Adjust images url
 */
export const formatConfiguration = (configuration: I.AppConfiguration, imgRootUrl: string) => {
  const formattedConfiguration = deepClone(configuration);

  ["client_bx2_footer_logo" as keyof I.AppConfiguration, "client_bx2_header_logo" as keyof I.AppConfiguration].forEach(
    (propertyName: keyof I.AppConfiguration) => {
      const property = formattedConfiguration[propertyName];

      if (property) {
        formattedConfiguration[propertyName] = isUrl(property) ? property : imgRootUrl + property;
      }
    },
  );

  return formattedConfiguration;
};

export const loadConfiguration =
  (imgRootUrl: string): AppThunk =>
  async (dispatch) => {
    dispatch(loadingConfiguration());

    // try {
    return await Promise.resolve();
    /*const payload = await API.getInit();

      if (payload?.appConfiguration) {
        const { appConfiguration } = payload;

        dispatch(configurationLoaded(
          'static',
          formatConfiguration(appConfiguration, imgRootUrl),
          getBrowserTimeZone(),
          imgRootUrl,
        ));
        return await Promise.resolve();
      }

      dispatch(loadingConfigurationFailed());
      return await Promise.reject();
    } catch (error) {
      dispatch(loadingConfigurationFailed());
      return Promise.reject();
    }*/
  };

export const endpointsInitialized = createAction(
  "configuration/endpointsInitialized",
  (jsfContextPath: string, jsfUrl: string, apiUrl: string, imgRootUrl: string) => ({
    payload: {
      jsfContextPath,
      jsfUrl,
      apiUrl,
      imgRootUrl,
    },
  }),
);

export const initializingEndpoints = createAction("configuration/initializingEndpoints");

// Set the context path:
// - default is none (aka root)
// - if the endpoint returns a value it will use it
const getContextPath = async (jsfUrl: string) => {
  let data;

  try {
    const response = await fetch(`${jsfUrl}${clientUrlPath("discovery/contextPath")}`);
    data = await response.text();
    if (response.status !== 200) data = "";
  } catch (e) {
    data = "";
  }

  return data.length >= 2 && data.startsWith("/") ? data : "/Selector";
};

export const initEndpoints = (): AppThunk => async (dispatch) => {
  dispatch(initializingEndpoints());

  // JAVA host:
  // default is the same domain as the react app is running on
  // otherwise specified via env variable
  // const defaultJAVAClientHost = hostname + (port ? `:${port}` : '');
  const defaultJAVAClientHost = urls.api;
  const JAVAClientHost = import.meta.env.VITE_JAVA_CLIENT_HOST || defaultJAVAClientHost;
  const jsfUrl = JAVAClientHost;
  const jsfContextPath = () => undefined; //await getContextPath(JAVAClientHost);
  const apiUrl = JAVAClientHost;
  const imgRootUrl = `//${JAVAClientHost}${jsfContextPath}`;

  dispatch(endpointsInitialized(jsfContextPath, jsfUrl, apiUrl, imgRootUrl));
  return Promise.resolve();
};

export const clientBuildIdLoaded = createAction("configuration/clientBuildIdLoaded", (clientBuildId: string) => ({
  payload: {
    clientBuildId,
  },
}));

export const loadClientBuildId = (): AppThunk => async (dispatch) => {
  const response = await fetch(clientUrlPath("client-build-id"));

  if (response) {
    const data = await response.text();
    if (data.length > 0 && data.length < 10) {
      dispatch(clientBuildIdLoaded(data));
    }
  }

  return Promise.resolve();
};
